module.exports = __webpack_public_path__ + "media/yoshi.e162b6d4.wav";